import React, { useState, useEffect, useRef } from "react";
import Classes from "./Profile.module.css";
import backend from "../../../../../../../api";
import { useSelector, useDispatch } from "react-redux";
import { setUserData } from "../../../../../../../redux-store/auth/actions";
import { CircularProgress } from "@mui/material";
import axios from "axios";
import { useSnackbar } from "notistack";

/* pencil icon unchanged */
const EditIcon = (p) => <svg {...p} viewBox="0 0 512 512"><path d="M410.3 231l11.3-11.3-33.9-33.9-62.1-62.1L291.7 89.8l-11.3 11.3-22.6 22.6L58.6 322.9c-10.4 10.4-18 23.3-22.2 37.4L1 480.7c-2.5 8.4-.2 17.5 6.1 23.7s15.3 8.5 23.7 6.1l120.3-35.4c14.1-4.2 27-11.8 37.4-22.2L387.7 253.7 410.3 231zM160 399.4l-9.1 22.7c-4 3.1-8.5 5.4-13.3 6.9L59.4 452l23-78.1c1.4-4.9 3.8-9.4 6.9-13.3l22.7-9.1v32c0 8.8 7.2 16 16 16h32zM362.7 18.7L348.3 33.2 325.7 55.8 314.3 67.1l33.9 33.9 62.1 62.1 33.9 33.9 11.3-11.3 22.6-22.6 14.5-14.5c25-25 25-65.5 0-90.5L453.3 18.7c-25-25-65.5-25-90.5 0zm-47.4 168l-144 144c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l144-144c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z" /></svg>;

const placeholders = { firstName: "John", lastName: "Smith", email: "john@site.com", phone: "(111)111‑1111", bio: "Designer" };

const ProfileCard = ({ settingsMenu }) => {
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const { user } = useSelector((s) => s.auth);
  const userId = user?._id;

  /* local state */
  const [isEditing, setIsEditing] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [showPwd, setShowPwd] = useState(() => { return settingsMenu === "change-password" ? true : false });
  console.log(settingsMenu);

  useEffect(() => {
    if (settingsMenu === "change-password") {
      setShowPwd(true);
    } else {
      setShowPwd(false);
    }
  }, [settingsMenu])

  const [imageURL, setImageURL] = useState(user?.imageURL ? [{ imgurl: user.imageURL }] : []);
  const imageInputRef = useRef(null);

  const [profile, setProfile] = useState({
    firstName: user?.firstName ?? "",
    lastName: user?.lastName ?? "",
    email: user?.email ?? "",
    phone: user?.phone ?? "",
    // bio: user?.bio ?? "",
  });

  const fetchUser = async () => {
    const res = await backend.put(`/api/user/${userId}`);
    const updated = { ...user, ...res.data.data };
    await dispatch(setUserData(updated));
  }

  const [pwd, setPwd] = useState({ Current_Password: "", New_Password: "", Confirm_Password: "" });

  useEffect(() => {
    if (!user) return;

    setProfile({ firstName: user.firstName ?? "", lastName: user.lastName ?? "", email: user.email ?? "", phone: user.phone ?? "" });
    setImageURL(user.imageURL ? [{ imgurl: user.imageURL }] : []);
  }, [user]);

  useEffect(() => {
    fetchUser();
  }, [])

  /* ---------- upload via your pattern ---------- */
  const uploadMedia = async (files) => {
    setUploading(true);
    try {
      const fd = new FormData();
      Array.from(files).forEach((f) => fd.append("files", f));
      const res = await axios.post(
        "https://aws-calendia-bc10efcc84bf.herokuapp.com/api/deck/upload",
        fd
      );
      const updated = res?.data?.data.map((d) => ({ ...d, key: d.name }));
      console.log("updated iMAGE", updated);
      setImageURL(updated);
      saveImage(updated[0]?.imgurl); // save image to user profile
      return updated[0]?.imgurl;
    } catch (err) {
      enqueueSnackbar(err.response?.data?.message || "Upload failed", { variant: "error" });
      throw err;
    } finally {
      setUploading(false);
    }
  };

  /* ---------- handlers ---------- */
  const toggleEdit = () => setIsEditing((v) => !v);
  const onText = (e) => setProfile({ ...profile, [e.target.name]: e.target.value });

  const handleFileChange = async (files) => {
    if (!files?.length) return;
    await uploadMedia(files); // state updates inside
  };

  const saveImage = async (img) => {
    const body = { ...profile, imageURL: img };
    try {
      const res = await backend.put(`/api/user/${userId}`, body);
      const updated = { ...user, ...res.data.data };
      await dispatch(setUserData(updated));
      localStorage.setItem("user", JSON.stringify(updated));
      enqueueSnackbar("Image updated!", { variant: "success" });
      setIsEditing(false);
    } catch (err) {
      enqueueSnackbar(err.response?.data?.message || "Update failed", { variant: "error" });
    }
  };



  const saveProfile = async () => {
    const body = { ...profile, imageURL: imageURL[0]?.imgurl };
    try {
      const res = await backend.put(`/api/user/${userId}`, body);
      const updated = { ...user, ...res.data.data };
      await dispatch(setUserData(updated));
      localStorage.setItem("user", JSON.stringify(updated));
      enqueueSnackbar("Profile updated!", { variant: "success" });
      setIsEditing(false);
    } catch (err) {
      enqueueSnackbar(err.response?.data?.message || "Update failed", { variant: "error" });
    }
  };

  const submitPassword = async () => {
    if (!pwd.Current_Password || !pwd.New_Password || !pwd.Confirm_Password)
      return enqueueSnackbar("Fill all password fields", { variant: "warning" });

    try {
      await backend.put(`/api/user/changepassword/${userId}`, pwd);
      enqueueSnackbar("Password changed!", { variant: "success" });
      setPwd({ Current_Password: "", New_Password: "", Confirm_Password: "" });
      setShowPwd(false);
    } catch (err) {
      enqueueSnackbar(err.response?.data?.message || "Password update failed", { variant: "error" });
    }
  };

  /* ---------- render ---------- */
  return (
    <div className={Classes.container}>

      {/* header */}
      {uploading ?
        <div className={Classes.profileHeader}> <label htmlFor="profileImage" className={Classes.card_img}>
          <CircularProgress />
        </label>
          <span className={Classes.userInfo}>{profile.firstName} {profile.lastName}</span>
        </div>
        :
        <div className={Classes.profileHeader}>
          <label htmlFor="profileImage" className={Classes.card_img}>
            <img src={imageURL[0]?.imgurl || "/assets/images/profile.png"} className={Classes.card_inner_img} />
            <img src="/assets/icons/camera.png" style={{ position: "relative", height: "1.2rem" }} />
          </label>
          <input
            id="profileImage"
            hidden
            type="file"
            accept="image/*"
            ref={imageInputRef}
            onChange={(e) => handleFileChange(e.target.files)}
          />
          <span className={Classes.userInfo}>{profile.firstName} {profile.lastName}</span>
        </div>}


      {/* body */}
      <div className={Classes.infoSection}>
        <div className={Classes.box2Header}>
          <h3>Personal information</h3>
          <button className={Classes.editButton} onClick={isEditing ? saveProfile : toggleEdit} disabled={uploading}>
            {isEditing ? "Save" : <><EditIcon height="12" fill="#969696" /> Edit</>}
          </button>
        </div>

        <div className={Classes.infoGrid}>
          {["firstName", "lastName", "email", "phone"].map((f) => (
            <div key={f}>
              <label className={Classes.label}><h5>{f.replace(/([A-Z])/g, " $1")}</h5></label>
              {isEditing && f !== "email" ? (
                <input name={f} type="text" value={profile[f]} onChange={onText} className={Classes.inputField} placeholder={placeholders[f]} />
              ) : (
                <p className={Classes.textValue}>{profile[f]}</p>
              )}
            </div>
          ))}
        </div>

        {/* password */}
        <div style={{ marginTop: "1.5rem" }}>
          <button className={Classes.editButton} onClick={() => setShowPwd((v) => !v)}>{showPwd ? "Cancel" : "Change Password"}</button>
          {showPwd && (
            <div className={Classes.infoGrid} style={{ marginTop: "1rem" }}>
              {["Current_Password", "New_Password", "Confirm_Password"].map((f) => (
                <div key={f}>
                  <label className={Classes.label}><h5>{f.replace("_", " ").replace(/(^.)/, c => c.toUpperCase())}</h5></label>
                  <input type="password" name={f} value={pwd[f]} onChange={(e) => setPwd({ ...pwd, [f]: e.target.value })} className={Classes.inputField} />
                </div>
              ))}
              <button className={Classes.updateBtn} onClick={submitPassword} style={{ gridColumn: "span 2", marginTop: "0.5rem" }}>
                <h5>Update Password</h5>
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProfileCard;
